module.exports = __webpack_public_path__ + "img/logo-uliege.1f181756.png";